import { Button, Flex, Text } from '@chakra-ui/react'
import { useState } from 'react'
import { iEmpresaMultiAcesso } from '../../../../contexts/AuthContext'
import { ModalBase } from '../../../ModalBase'
import { SearchCmp } from '../../../SearchCmp'

const LOGO_AH = 'https://sigah.blob.core.windows.net/onboard/c9e9829f-2162-4b72-926c-3d233a8a053a.png'

interface iModalSelecaoEmpresaProps {
  isOpen: boolean
  onClose: () => void
  empresas: iEmpresaMultiAcesso[]
  onSelecionar: (empresa: iEmpresaMultiAcesso) => void
  onRetornar: () => void
}

export const ModalSelecaoEmpresa: React.FC<iModalSelecaoEmpresaProps> = ({ isOpen, onClose, empresas, onSelecionar, onRetornar }) => {
  const [busca, setBusca] = useState('')

  const empresasFiltradas = empresas.filter(e => e.nome.toLowerCase().includes(busca.toLowerCase()))

  return (
    <ModalBase
      isOpen={isOpen}
      onClose={onClose}
      Titulo='Selecionar empresa'
      Width='28rem'
    >
      <Flex flexDirection={'column'} gap={'1rem'} p={'3rem'}>
        <SearchCmp
          placeholder='Buscar empresa'
          width='100%'
          value={busca}
          OnChange={setBusca}
          EnterAction={() => {}}
        />

        <Flex flexDirection={'column'} maxH={'20rem'} overflowY={'auto'} gap={'.25rem'}>
          {empresasFiltradas.map(empresa => (
            <Flex
              key={empresa.empresaId}
              alignItems={'center'}
              gap={'.75rem'}
              p={'.5rem'}
              borderRadius={'.25rem'}
              cursor={'pointer'}
              transition={'all 0.2s'}
              _hover={{ bg: 'var(--Rosa)' }}
              onClick={() => {
                // TODO: trocar empresa ativa no backend quando o endpoint existir
                onSelecionar(empresa)
                onClose()
              }}
            >
              <img
                src={empresa.logo}
                style={{ height: '1.5rem', width: '1.5rem', borderRadius: '.25rem', objectFit: 'contain' }}
              />
              <Text fontSize={'.875rem'} fontWeight={'500'}>{empresa.nome}</Text>
            </Flex>
          ))}
        </Flex>

        <Button
          w={'100%'}
          mt={'2rem'}
          bg={'var(--Azul)'}
          color={'white'}
          fontSize={'.875rem'}
          leftIcon={<img src={LOGO_AH} style={{ height: '1.25rem', width: '1.25rem', borderRadius: '.25rem', objectFit: 'contain' }} />}
          _hover={{ bg: 'var(--AzulClaro2)' }}
          _active={{ bg: 'var(--AzulClaro2)' }}
          onClick={() => {
            onRetornar()
            onClose()
          }}
        >
          Retornar para Arquitetura Humana
        </Button>
      </Flex>
    </ModalBase>
  )
}
